/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessGiftCards.internal

import features.userBusinessGiftCards.models.UserBusinessGiftCardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessGiftCardsRequest : NetworkRequest() {

    suspend fun getUserBusinessGiftCards(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<UserBusinessGiftCardsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessGiftCardsEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
